
import Dialog from '~/components/ui/Dialog.vue'

export default {
    name: 'ConversionMinutesHintDialog',
    components: { Dialog, },
    data: () => ({
        convertionMinutes: {
            conversion: {
                title: 'conversion_tasks',
                consumption: [
                    { inputFile: 'Image', outputFile: 'Image', convertionMinutes: [{ size: '10MB', minute: 1 }, { size: '100MB', minute: 1 }, { size: '1GB', minute: 1 }] },
                    { inputFile: 'Image', outputFile: 'document', convertionMinutes: [{ size: '10MB', minute: 1 }, { size: '100MB', minute: 1 }, { size: '1GB', minute: 2 }] },
                    { inputFile: 'audio', outputFile: 'audio', convertionMinutes: [{ size: '10MB', minute: 1 }, { size: '50MB', minute: 1 }, { size: '100MB', minute: 2 }] },
                    { inputFile: 'video', outputFile: 'video', convertionMinutes: [{ size: '500MB', minute: 2 }, { size: '2GB', minute: 5 }, { size: '4GB', minute: 6 }] },
                    { inputFile: 'video', outputFile: 'audio', convertionMinutes: [{ size: '100MB', minute: 1 }, { size: '1GB', minute: 1 }, { size: '2GB', minute: 1 }] },
                    { inputFile: 'document', outputFile: 'document', convertionMinutes: [{ size: '10MB', minute: 1 }, { size: '50MB', minute: 1 }, { size: '100MB', minute: 1 }] },
                ]
            },
            compression: {
                title: 'compression_tasks',
                consumption: [
                    { inputFile: 'Image', convertionMinutes: [{ size: '10MB', minute: 1 }, { size: '100MB', minute: 3 }, { size: '1GB', minute: 7 }] },
                    { inputFile: 'audio', convertionMinutes: [{ size: '10MB', minute: 1 }, { size: '100MB', minute: 1 }, { size: '1GB', minute: 2 }] },
                    { inputFile: 'video', convertionMinutes: [{ size: '100MB', minute: 1 }, { size: '1GB', minute: 5 }, { size: '2GB', minute: 14 }] },
                    { inputFile: 'document', convertionMinutes: [{ size: '10MB', minute: 1 }, { size: '100MB', minute: 1 }, { size: '1GB', minute: 2 }] },
                ]
            }
        }
    }),
    computed: {
        baseUrl() { return process.env.BASE_URL },
        isMobile() { return this.$store.state.store.isMobile },
    },
    created() {
    },
    methods: {
        open(props) {
            this.openDialog()
        },
        openDialog() {
            this.$refs.ConversionMinutesHintDialog.open()
        }
    }
}
